import _findIndex from 'lodash/findIndex'

class MyGarageController {
  constructor (UserService, VehicleService, $state, $stateParams, $rootScope, $location, $anchorScroll, $timeout, $scope, MetricsService) {
    'ngInject'
    this.isProcessing = true
    this.vehicleService = VehicleService
    this.metricsService = MetricsService
    this.$state = $state
    this.$timeout = $timeout
    this.$stateParams = $stateParams
    this.$rootScope = $rootScope
    this.$location = $location
    this.$anchorScroll = $anchorScroll
    this.$scope = $scope
    this.isProcessing = true
    this.vehicles = [null]
    this.$scope.$watch('$ctrl.vehicleIndex', this.vehicleIndexChanged())
    this.loaded = this.init()
  }

  init () {
    return this.vehicleService.getCurrentUserVehicles()
    .then((vehicles) => {
      this.isProcessing = false
      this.vehicles = [...vehicles, null]
      const addedVin = this.$stateParams.vin
      if (addedVin && (addedVin.length === 17 || addedVin.length === 64)) {
        const index = _findIndex(this.vehicles, ['vin', addedVin])
        if (index === -1) {
          this.setVehicleIndex(0)
        } else {
          this.success = 'my-garage.addVehicleForm.success'
          this.setVehicleIndex(index)
          this.$location.hash('appMessage')
        }
      }
      return this.metricsService.endPageLoadTime(200)
    })
  }

  setVehicleIndex (index) {
    // FIXME Hack while waiting for PR to be merged https://github.com/revolunet/angular-carousel/pull/312
    this.$timeout(() => {
      this.vehicleIndex = index
    }, 500)
  }

  vehicleIndexChanged () {
    return () => {
      this.$rootScope.$broadcast('editVehicle:close')
      this.$rootScope.$broadcast('deleteVehicle:close')
    }
  }

  refresh () {
    return this.vehicleService.getCurrentUserVehicles(false)
    .then((vehicles) => {
      this.vehicles = [...vehicles, null]
      this.isProcessing = false
      this.$rootScope.$broadcast('vehicles:update')
    })
  }

  get currentVehicle () {
    return this.vehicles[this.vehicleIndex]
  }

  getCurrentVehicleProductsUrl () {
    if (this.currentVehicle) {
      return this.$state.href('vehicle', {vin: this.currentVehicle.vin, sync: true})
    }
  }

  getVehicleImage (vehicle) {
    // TODO how to extract model code from vehicle
    // We have tu update the API to have better dataset when an user is connected
    return vehicle && vehicle.modelCode ? `img/photos/vehicles/${vehicle.modelCode}.png` : 'img/photos/vehicule.gif'
  }

  deleteCurrentVehicle () {
    this.isProcessing = true
    return this.vehicleService.deleteVehicle(this.currentVehicle.vin)
    .then((success) => {
      this.isProcessing = false
      this.success = 'my-garage.delete-vehicle.success'
      this.error = null
      this.vehicles.splice(this.vehicleIndex, 1)
      if (this.vehicleIndex > 0) {
        this.vehicleIndex--
      }
      this.refresh()
      this.$location.hash('appMessage')
      this.$anchorScroll()
      // TODO fixme $('[id="appMessage"]').focus()
    }, (err) => {
      this.isProcessing = false
      this.error = {
        message: 'my-garage.delete-vehicle.error',
        cause: err
      }
      this.$location.hash('appMessage')
      this.$anchorScroll()
      // TODO fixme $('[id="appMessage"]').focus()
    })
  }

  editCurrentVehicle (name) {
    this.isProcessing = true
    const v = Object.assign({}, this.currentVehicle, {name})
    return this.vehicleService.editVehicle(v)
    .then((success) => {
      this.isProcessing = false
      this.success = 'my-garage.edit-vehicle.success'
      this.error = null
      this.refresh()
    }, (err) => {
      this.isProcessing = false
      this.error = {
        message: 'my-garage.edit-vehicle.error',
        cause: err
      }
    })
  }
}

export default MyGarageController



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-garage/my-garage.controller.js